import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { useCallback, useState } from 'react';
import { MoreEffective } from 'shared/components/MoreEffective';
import { animateOffersCards } from 'shared/utils/animateOffersCards';
import { animatePins } from 'shared/utils/animatePins';

export const MoreEffectiveContainer: React.FC = () => {
  const { state: switcherEnabled, toggle: toggleSwitcherEnabled } = useToggleState();

  const [activeVas, setActiveVas] = useState(0);

  const device = useDeviceType();

  const handleChangeService = useCallback((serviceId: number) => {
    animateOffersCards(serviceId);
    setActiveVas(serviceId);
  }, []);

  const handleSwitcher = useCallback(() => {
    toggleSwitcherEnabled();

    animatePins(!switcherEnabled);
  }, [switcherEnabled, toggleSwitcherEnabled]);

  return (
    <MoreEffective
      device={device}
      activeVas={activeVas}
      pinIsActive={switcherEnabled}
      onChangePinActive={handleSwitcher}
      onChangeService={handleChangeService}
    />
  );
};
